import { GetterTree } from 'vuex';
import { RootState } from '@/interface/store/';
import { Request } from '@/interface/store/request';

export const getters: GetterTree<Request, RootState> = {
  getterDataList: (state) => state.dataList,
  getterDataTotalCount: (state) => state.totalCount,
  getterQueryParams: (state) => state.queryParams,
  getterStatusCount: (state) => state.statusCount,
  getterData: (state) => state.requestData,
  getterComments: (state) => state.requestComments,
  getterAttachments: (state) => state.requestAttachments,
  getterPoList: (state) => state.poList,
  getterRequestHistories: (state) => state.requestHistories,
  getterRequestFilter: (state) => state.requestFilter,
  getterRequestFilterStack: (state) => state.requestFilterStack,
  getterIsDrawerOpen: (state) => state.isDrawerOpen,
  getterIsTooltipShown: (state) => state.isTooltipShown,
};
